import { Map } from 'immutable';

import * as FPAIConstants from './constants';
import * as D from './deps';

const INITIAL_STATE = Map({
  [FPAIConstants.ReducerKeys.FAMILY_PLAN_INVITE_TOKEN]: '',
  [FPAIConstants.ReducerKeys.IS_VALID_FAMILY_PLAN_INVITE_TOKEN]: false,
});

export default D.createReducer(INITIAL_STATE, {
  [FPAIConstants.Actions.SET_FAMILY_PLAN_INVITE_CODE]: onSetFamilyPlanInviteCode,
  [D.Constants.Api.ApiActions.FAMILY_PLAN_ACCEPT_INVITE_SUCCESS]: onAcceptFamilyPlanInviteSuccess,
});

function onSetFamilyPlanInviteCode(state, { payload: { familyPlanInviteToken } }) {
  return state.set(FPAIConstants.ReducerKeys.FAMILY_PLAN_INVITE_TOKEN, familyPlanInviteToken);
}

function onAcceptFamilyPlanInviteSuccess(state) {
  return state.merge({
    [FPAIConstants.ReducerKeys.IS_VALID_FAMILY_PLAN_INVITE_TOKEN]: true,
  });
}
